import { render, staticRenderFns } from "./ShowcaseProjectSelect.vue?vue&type=template&id=05888578&"
import script from "./ShowcaseProjectSelect.vue?vue&type=script&lang=ts&"
export * from "./ShowcaseProjectSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports